import React, { FC } from 'react'
import DoneIcon from '@material-ui/icons/Done'
import { FaRegTimesCircle } from 'react-icons/fa'
import './styles.scss'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CircleCheckboxIcon: FC<any> = ({ state, disabled, type = 'normal', isWhiteIcon }) => {
  if (type === 'times' && state) {
    return <FaRegTimesCircle className="times" />
  }
  return (
    <div
      className={`icon-container ${isWhiteIcon ? 'icon-white' : ''} ${state ? 'checked' : ''} ${
        disabled ? 'disabled' : ''
      }`}
    >
      {type === 'normal' && <DoneIcon />}
    </div>
  )
}

export default CircleCheckboxIcon
